"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
exports.default = ((typeof window !== 'undefined' ? window : global) || {});
//# sourceMappingURL=global.js.map